// Centralized API base URL configuration
// - Dev (npm start): defaults to http://localhost:3001
// - Prod (deploy.sh): REACT_APP_API_URL is set to the production URL at build time

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default API_URL;
